import { Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { Estate_FieldsFragment } from 'queries';
import { FileText } from 'ts-react-feather-icons';

const useStyles = makeStyles(() => ({
  link: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  stackedDataFirst: {
    display: 'block',
    lineHeight: '1.43',
    width: '100%',
  },
}));

type EstateWorkItemVaultDetailsProps = {
  handleImpersonateView: (view: string) => void;
  estate: Estate_FieldsFragment;
};

const EstateWorkItemVaultDetails = ({
  handleImpersonateView,
  estate,
}: EstateWorkItemVaultDetailsProps) => {
  const classes = useStyles();
  const vaultLastUpdatedByUserDate = estate.vaultLastUpdatedByUserDate;

  return (
    <div>
      <Link className={classes.link} onClick={() => handleImpersonateView('documents')}>
        <FileText /> Click to view vault documents
      </Link>
      <div className={classes.stackedDataFirst}>
        <strong>Last Updated By User Date:</strong>
      </div>
      {vaultLastUpdatedByUserDate ? (
        <div className={classes.stackedDataFirst}>
          <div>
            <Typography variant="caption">
              {format(Date.parse(vaultLastUpdatedByUserDate), 'LLL d y')}
            </Typography>
          </div>
          <div className={classes.stackedDataFirst}>
            <Typography variant="caption">
              {format(Date.parse(vaultLastUpdatedByUserDate), 'h:mm aaa')}
            </Typography>
          </div>
        </div>
      ) : (
        'N/A'
      )}
    </div>
  );
};
export default EstateWorkItemVaultDetails;
